import { assetUrl } from "../assetVer.js";

/**
 * GhostLand is a 3D desktop experience; mobile isn't ready yet. We detect a phone/tablet (mobile UA, or a
 * touch-primary device with a small viewport) and show a full-screen "under construction" notice instead
 * of booting the game.
 */
export function isMobile(): boolean {
  const ua = navigator.userAgent || "";
  if (/Mobi|Android|iPhone|iPod|iPad|Windows Phone|BlackBerry|IEMobile/i.test(ua)) return true;
  // Touch-PRIMARY device (coarse pointer, no hover) ⇒ phone/tablet, regardless of window size.
  // NOT maxTouchPoints/window size: touchscreen laptops report touch points, and a laptop window's
  // innerHeight is almost always < 768 — that combination gated real desktops. Touchscreen
  // laptops report a fine pointer + hover, so they pass this check and boot normally.
  return matchMedia("(pointer: coarse)").matches && matchMedia("(hover: none)").matches;
}

/** Full-screen black notice (matches the minimal design) with a pixelated construction hat. Mounts once. */
export function showMobileGate(): void {
  if (document.getElementById("gl-mobile-gate")) return;
  const el = document.createElement("div");
  el.id = "gl-mobile-gate";
  el.style.cssText =
    "position:fixed;inset:0;z-index:99999;background:#000;color:#e8e8e8;"
    + "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:24px;"
    + "padding:32px;box-sizing:border-box;text-align:center;"
    + "font-family:ui-monospace,'SFMono-Regular',Menlo,monospace;";

  const hat = document.createElement("img");
  hat.src = assetUrl("/assets/ui/construction_hat.png");
  hat.alt = "under construction";
  hat.style.cssText = "width:128px;height:128px;image-rendering:pixelated;filter:drop-shadow(0 6px 18px rgba(0,0,0,.7));";

  const title = document.createElement("div");
  title.textContent = "Under Construction";
  title.style.cssText = "font-size:22px;font-weight:800;letter-spacing:2px;";

  const body = document.createElement("div");
  body.textContent = "GhostLand's mobile experience is still being built. Hop on a desktop for the full experience.";
  body.style.cssText = "font-size:14px;line-height:1.65;max-width:360px;opacity:.82;";

  el.append(hat, title, body);
  document.body.appendChild(el);

  // Self-recover from a false positive (device emulation closed, UA-spoofing extension off,
  // external mouse plugged into a tablet): if the environment stops looking mobile, reload
  // straight into the real game — the boot path returned early, so a reload is the restart.
  window.addEventListener("resize", () => {
    if (!isMobile()) location.reload();
  });
}
